import { render, staticRenderFns } from "./GmFooter.vue?vue&type=template&id=e631bb90&scoped=true&"
import script from "./GmFooter.vue?vue&type=script&lang=ts&"
export * from "./GmFooter.vue?vue&type=script&lang=ts&"
import style0 from "./GmFooter.vue?vue&type=style&index=0&id=e631bb90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e631bb90",
  null
  
)

export default component.exports